import React, { useContext, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { GlobalContext } from '../../../../helper/context'
import NoteChart from '../../../Dashboard/noteChart'
import { BoxClass } from '../../../../helper/classes'

function StatisticsAddOn () {
  const context = useContext(GlobalContext)

  return useMemo(() => (
    <div css={css`min-height: 100%; height: 300px;`}>
      {((context.configReady && context.treeNodesReady) ? <NoteChart sharingAddonMode /> : null)}
    </div>
  )
  , [context.configReady, context.treeNodesReady])
}

const StatisticsAddOnBoxClass = new BoxClass(StatisticsAddOn, 'Statistics', null, 'sharing', { order: 6, onlyForTheseLocations: [ '/sharing' ]})

export default StatisticsAddOnBoxClass
